import firebase from 'firebase';
const config = {
    apiKey: "AIzaSyDPiqAO7fqaH4wPcvTJVlm1WGScnj4tOrU",
    authDomain: "shift-planner-b534f.firebaseapp.com",
    projectId: "shift-planner-b534f",
    storageBucket: "shift-planner-b534f.appspot.com",
    messagingSenderId: "657762271951",
    appId: "1:657762271951:web:618c8f1f7f0a301a25edba",
    measurementId: "G-1F3ER9QM0B"
};
// Initialize Firebase
firebase.initializeApp(config);
firebase.analytics();

export default firebase;